import { render, staticRenderFns } from "./60.vue?vue&type=template&id=3c230bc8&scoped=true&"
var script = {}
import style0 from "./60.vue?vue&type=style&index=0&id=3c230bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c230bc8",
  null
  
)

export default component.exports